import { InternalStepOption } from '@booking-booster-client/models';

export const step1: InternalStepOption = {
  anchorId: 'campaigns-table',
  stepId: 'campaigns-table',
  titleTranslationKey: 'ui_tours.statistics_campaigns.step1.title',
  contentTranslationKey: 'ui_tours.statistics_campaigns.step1.content',
  route: '/statistics/campaigns',
};
